// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"65fb754a","239":"4f2a9643","667":"7f4d3fa5"}[chunkId] + ".chunk.js";
};